import styled from 'styled-components';
import { Rate } from 'antd';

export const StyledRate = styled(Rate)<{ disabled: boolean }>`
  line-height: 22px;
  li:not(.ant-rate-star-full) {
    img {
      filter: brightness(95%);
    }
  }
  img {
    margin-bottom: 3px;
  }
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
